import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement, ReactNode } from 'react'
import { Shimmer } from '~/components/Global/Elements/Shimmer/Shimmer'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  kpiCard,
  kpiInfo,
  kpiLabel,
  kpiLabelRow,
  kpiValue,
  kpiValueRow,
  kpiValueShimmer
} from './KpiCard.css'

export const KpiCard = ({
  label,
  value,
  trend,
  info,
  isLoading = false
}: {
  label: string
  value: ReactNode
  trend?: ReactNode
  info?: string
  isLoading?: boolean
}): ReactElement => {
  return (
    <div className={kpiCard}>
      <div className={kpiLabelRow}>
        <div className={kpiLabel}>{label}</div>
        {info && (
          <Tooltip text={info} direction="top" asChild>
            <button type="button" className={kpiInfo} aria-label="Aide">
              <FontAwesomeIcon icon={faCircleInfo} />
            </button>
          </Tooltip>
        )}
      </div>
      {isLoading ? (
        <Shimmer className={kpiValueShimmer} />
      ) : (
        <div className={kpiValueRow}>
          <div className={kpiValue}>{value}</div>
          {trend}
        </div>
      )}
    </div>
  )
}
